<template>
  <div>
    <Header />
    <div class="pt80">
      <div id="section1">
        <div class="container">
          <div class="th">
            <span> {{ $t("header.nav2") }}</span>
            <i class="el-icon-arrow-right"></i>
            <i class="el-icon-arrow-right"></i>
          </div>
          <div class="th2">{{ $t("acc.th") }}</div>
          <div class="txt">{{ $t("acc.tit") }}<br />{{ $t("acc.tit2") }}</div>
        </div>
      </div>

      <div id="section2">
        <div class="container">
          <div class="subtit">
            <svgIcon className="icon" iconName="icon-acc2"></svgIcon>
            <div>
              <div class="th2">{{ $t("acc.sec1.tit") }}</div>
              <div class="tips">
                {{ $t("acc.sec1.tips") }}
              </div>
            </div>
          </div>
          <div class="d-flex align-items-center">
            <div class="d-flex flex-wrap" style="width: 600px">
              <div
                class="currency"
                v-for="(cur, index) in currency"
                :key="index"
              >
                <svg-icon className="icon" :iconName="cur.iconName"></svg-icon>
                <div class="txt">{{ cur.name }}</div>
              </div>
            </div>
            <img
              src="@/assets/acc-1.png"
              width="336px"
              style="margin-left: 50px"
            />
          </div>
        </div>
      </div>

      <div id="section3" class="">
        <div class="container">
          <div class="list d-flex align-items-center">
            <div class="item" v-for="i in 7">
              <svgIcon className="icon" :iconName="`icon-acc${i}`"></svgIcon>
              <div>
                <div class="th2">{{ $t(`acc.sec2.t${i}`) }}</div>
                <div class="tips">
                  {{ $t(`acc.sec2.tips${i}`) }}
                </div>
              </div>
            </div>
          </div>
          <div class="th">{{ $t("acc.th2") }}</div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";
export default {
  name: "personal",
  components: { Header, Footer },
  data() {
    return {
      currencyZH: [
        { name: "美元", iconName: "icon-my" },
        { name: "人民币", iconName: "icon-rmb" },
        { name: "欧元", iconName: "icon-oy" },
        { name: "英镑", iconName: "icon-yb" },
        { name: "日元", iconName: "icon-ry" },
        { name: "澳元", iconName: "icon-ay" },
        { name: "港元", iconName: "icon-gy" },
        { name: "挪威克朗", iconName: "icon-nwkl" },
        { name: "新西兰元", iconName: "icon-xxl" },
        { name: "墨西哥比索", iconName: "icon-mxg" },
        { name: "瑞典克朗", iconName: "icon-rd" },
        { name: "加拿大元", iconName: "icon-jnd" },
        { name: "南非兰特", iconName: "icon-nf" },
        { name: "泰铢", iconName: "icon-tz" },
        { name: "瑞士法郎", iconName: "icon-rs" },
        { name: "新加坡元", iconName: "icon-xjp" },
        { name: "丹麦克朗", iconName: "icon-dm" },
      ],
      currencyEN: [
        { name: "USD", iconName: "icon-my" },
        { name: "CNY", iconName: "icon-rmb" },
        { name: "EUR", iconName: "icon-oy" },
        { name: "GBP", iconName: "icon-yb" },
        { name: "JPY", iconName: "icon-ry" },
        { name: "AUD", iconName: "icon-ay" },
        { name: "HKD", iconName: "icon-gy" },
        { name: "NOK", iconName: "icon-nwkl" },
        { name: "NZD", iconName: "icon-xxl" },
        { name: "MXN", iconName: "icon-mxg" },
        { name: "SEK", iconName: "icon-rd" },
        { name: "CAD", iconName: "icon-jnd" },
        { name: "ZAR", iconName: "icon-nf" },
        { name: "THB", iconName: "icon-tz" },
        { name: "CHF", iconName: "icon-rs" },
        { name: "SGD", iconName: "icon-xjp" },
        { name: "DKK", iconName: "icon-dm" },
      ],
    };
  },
  computed: {
    // ...mapGetters([
    // 'user'
    // ]),
    disabled() {
      if (this.phone && this.code && this.qq) {
        return false;
      } else {
        return true;
      }
    },
    currency() {
      if (this.$i18n.locale == "en") {
        return this.currencyEN;
      } else {
        return this.currencyZH;
      }
    },
  },
  mounted() {
    localStorage.setItem("channel", this.$route.query.channel);
  },
  methods: {
    toProduct() {
      this.$router.push("/product");
    },
    openAbout() {
      window.open(`${this.httpIp}/#/about`);
    },
    openLogin() {
      this.$router.push("/login");
    },

    changeCarousel(index) {
      console.log(index);
      this.carouselIndex = index;
    },
  },
};
</script>

<style lang="less" scoped>
.pt80 {
  padding-top: 80px;
}
.container {
  padding: 0;
}

#section1 {
  height: 203px;
  background-image: url(~@/assets/acq-1.png);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  overflow: hidden;
  .container {
    position: relative;
  }
  .th {
    margin-top: 18px;
    font-weight: 500;
    font-size: 20px;
    color: #3b3b3b;
    line-height: 20px;
    i {
      &:last-child {
        margin-left: -20px;
      }
    }
  }
  .th2 {
    margin-top: 11px;
    margin-bottom: 11px;
    font-weight: 300;
    font-size: 64px;
    color: #1485ef;
    line-height: 64px;
  }
  .txt {
    font-weight: 350;
    font-size: 16px;
    color: #000000;
    line-height: 28px;
  }
}

#section2 {
  padding-top: 46px;
  .subtit {
    margin-bottom: 33px;
    display: flex;
    align-items: center;
    .icon {
      margin-right: 17px;
      font-size: 46px;
    }
    .th2 {
      font-weight: 700;
      font-size: 18px;
      color: #000000;
      line-height: 22px;
    }
    .tips {
      margin-top: 9px;
      font-weight: 350;
      font-size: 14px;
      color: #9e9e9e;
      line-height: 21px;
    }
  }
  .currency {
    position: relative;
    margin-right: 30px;
    height: 80px;
    .icon {
      font-size: 48px;
    }
    .txt {
      position: absolute;
      top: 50px;
      left: 50%;
      transform: translateX(-50px);
      width: 100px;
      font-weight: 500;
      font-size: 14px;
      color: #000000;
      line-height: 21px;
      text-align: center;
    }
  }
  .box {
    display: flex;
    align-items: center;
    .item {
      margin-right: 20px;
      padding: 30px;
      width: 208px;
      height: 360px;
      border-radius: 25px 25px 25px 25px;
      background-repeat: no-repeat;
      background-size: cover;
      cursor: pointer;
      &.part1 {
        background-image: url(~@/assets/part1-dis.png);
        background-size: 278px 430px;
        background-position: -35px -20px;
      }
      &.part2 {
        background-image: url(~@/assets/part2-dis.png);
        background-size: 278px 430px;
        background-position: -35px -20px;
      }
      &.part3 {
        background-image: url(~@/assets/part3-dis.png);
        background-size: 278px 430px;
        background-position: -35px -20px;
      }
      &.part4 {
        background-image: url(~@/assets/part4-dis.png);
        background-size: 278px 430px;
        background-position: -35px -20px;
      }
      .th2 {
        font-weight: 700;
        font-size: 28px;
        color: #7291ad;
        line-height: 34px;
      }
      .tips {
        margin-top: 168px;
        display: none;
        font-weight: 400;
        font-size: 16px;
        color: #ffffff;
        line-height: 32px;
      }
      &.mouseover {
        width: 300px;
        height: 360px;
        &.part1 {
          background-image: url(~@/assets/part1.png);
          background-size: 370px 430px;
          background-position: -35px -20px;
        }
        &.part2 {
          background-image: url(~@/assets/part2.png);
          background-size: 370px 430px;
          background-position: -35px -20px;
        }
        &.part3 {
          background-image: url(~@/assets/part3.png);
          background-size: 370px 430px;
          background-position: -35px -20px;
        }
        &.part4 {
          background-image: url(~@/assets/part4.png);
          background-size: 370px 430px;
          background-position: -35px -20px;
        }
        .th2 {
          color: #fff;
        }
        .tips {
          display: block;
        }
      }
    }
  }
  .content {
    position: relative;
    padding-top: 163px;
    padding-left: 29px;
    .th2 {
      font-weight: 300;
      font-size: 42px;
      color: #1485ef;
      line-height: 51px;
    }
    .th3 {
      font-weight: 300;
      font-size: 42px;
      line-height: 51px;
      color: #000000;
    }
    .btn {
      margin-top: 45px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 169px;
      height: 54px;
      background: linear-gradient(270deg, #1485ef 0%, #1485ef 100%);
      border-radius: 30px;
      font-weight: 500;
      font-size: 20px;
      color: #ffffff;
      span {
        margin-right: 10px;
      }
    }
    .pic {
      position: absolute;
      top: -100px;
      left: 140px;
    }
  }
}
#section3 {
  margin-top: 100px;
  .list {
    flex-wrap: wrap;
    .item {
      width: 25%;
      margin-bottom: 26px;
      .icon {
        font-size: 46px;
      }
      .th2 {
        margin-top: 11px;
        font-weight: 700;
        font-size: 18px;
        color: #000000;
        line-height: 22px;
      }
      .tips {
        margin-top: 15px;
        font-weight: 350;
        font-size: 14px;
        color: #9e9e9e;
        line-height: 21px;
        width: 190px;
      }
    }
  }
  .th {
    padding: 40px 0;
    font-weight: 300;
    font-size: 64px;
    color: #1485ef;
    line-height: 64px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/product/account.vue